<template>
  <div>
    <input
      class="form-control"
      type="text"
      id="postcode"
      name="postcode"
      :value="value"
      @input="updateValue($event.target.value)"
      :placeholder="placeholder"
      v-validate="'required|postcode'"
    />
    <div class="invalid-feedback">
      {{ dictionary.errorMessage }}
    </div>
  </div>
</template>

<script>
import log from "loglevel";
import { GetTranslations } from "../services/translation.service";

export default {
  name: "PostcodeField",
  props: {
    value: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "0000",
    },
  },
  data() {
    return {
      validated: false,
      dictionary: GetTranslations("postcode")
    };
  },
  methods: {
    updateValue: function (value) {
      let me = this;
      this.$validator.validate().then((valid) => {
        me.$emit("input", value);
        if (me.validated || value.length > 3) {
          if (valid) {
            log.info("Postcode is valid", value);
          }
          me.validated = true;
          me.$emit("validated", valid);
        }
      });
    },
  },
};
</script>